import React, {CSSProperties, ReactNode} from "react";
import {withTranslation} from "react-i18next";
import {withHostApi} from "../../contexts/HostApiContext";
import Icons from "../Icons";
import Modal from "react-responsive-modal";
import {colorData, fileInfos} from "./SmallOrderTable";
import {CheckboxConformite} from "./CheckboxConformite";

interface ModalControlProps {
  onOpenModalControl: () => void;
  openModalControl: boolean;
  fileInfos?: fileInfos
  typeTransfer: string;
  t: (arg0: string) => ReactNode;
  contourCss?: CSSProperties;
  hostApi: string;
  handleOnAddCartBtnClick: () => void;
  colorData?: colorData;
}

interface ModalControlState {
  checkConformite: boolean;
}

class ModalControl extends React.Component<ModalControlProps, ModalControlState> {
  constructor(props: ModalControlProps) {
    super(props);
    this.state = {
      checkConformite: false
    }
  }

  _onUpdatedConformite = (isChecked: boolean) => {
    const conformite = document.getElementById('divConformite');
    if (conformite) {
      conformite.classList.remove('alert-danger');
      conformite.classList.add('alert-warning');
    }

    this.setState({
      checkConformite: isChecked
    });
  }

  _onClickAddToCart = () => {
    const conformite = document.getElementById('divConformite');

    if(this.state.checkConformite) {
      this.props.handleOnAddCartBtnClick();
      if (conformite) {
        conformite.classList.remove('alert-danger');
        conformite.classList.add('alert-warning');
      }
    } else {
      if (conformite) {
        conformite.classList.add('alert-danger');
        conformite.classList.remove('alert-warning');
      }
    }
    this.setState({
      checkConformite: false
    });
  }

  render() {
    return (
        <Modal open={this.props.openModalControl} onClose={this.props.onOpenModalControl} classNames={{modal: "zoomModalFinesseControl"}}
               center>
          <div className={'p-md-2'}>
            {this.props.fileInfos?.finesse && ['c', 'dtf'].includes(this.props.typeTransfer) ?
                <div className={"alert-warning text-center p-2 mb-2"}>
                  <p className={"mb0"}>
                    <Icons icon={'warning'} size={20} fill={"red"} className="mr-1" />
                    {this.props.t('finesse_warning')}
                  </p>
                  <p className={"mb0"}>
                    {this.props.t('finesse_warning2')}
                  </p>
                </div> : ''
            }
            <div className={`align-self-center d-flex  flex-column`} >
              {this.props.fileInfos && <div className={`position-relative  `}>
                  <div className={'d-flex align-items-center justify-content-center'}>
                      <div className={`position-relative containerImgControl`}>
                          <img className={`img-fluid imgControl imgControlMain`} style={this.props.contourCss} src={`${this.props.hostApi}${this.props.fileInfos.miniature}`}/>
                        {this.props.fileInfos.finesse && ['c', 'dtf'].includes(this.props.typeTransfer) &&
                            <img className="finesse-img img-fluid imgControl" src={`${this.props.hostApi}${this.props.fileInfos.finesse}`} style={{padding: "20px"}}/>
                        }
                      </div>
                  </div>
              </div>}
            </div>
            <CheckboxConformite isChecked={this.state.checkConformite} onUpdatedConformite={this._onUpdatedConformite} traduction={this.props.t}/>
            <div className={"d-flex justify-content-between"}>
              <button id={"reupload_btn"} className={'btn btn-dt-primary d-flex align-items-center justify-content-center cursor-pointer'} onClick={this.props.onOpenModalControl}>
                <Icons icon="close" size={25} className={'mr-2'}/>
                {this.props.t('cancel')}
              </button>
              {this.props.fileInfos &&
                  <div className={"bg-white black text-center py-1 mx-4"}>
                      <span className="px-1 bold font20">{this.props.fileInfos?.dimensionsCM?.largeur}cm x {this.props.fileInfos?.dimensionsCM?.hauteur}cm</span>
                    {this.props.colorData && this.props.typeTransfer === 'ce' &&
                        <div className={"bg-white grey  text-center py-1 "}>
                            <span>{this.props.t('fabric_color')} : </span>
                            <span className={"pl-3 pr-3 mx-2"} title={`${this.props.t('cyan')}: ${this.props.colorData?.c} ${this.props.t('magenta')}: ${this.props.colorData?.m} ${this.props.t('jaune')}: ${this.props.colorData?.j} ${this.props.t('noir')}: ${this.props.colorData?.n}`}
                                  style={{border: "1px solid black", backgroundColor: `#${this.props.colorData?.hexadecimal}`}}>&nbsp;</span>
                            <span>{this.props.t('cyan')}: {this.props.colorData?.c} {this.props.t('magenta')}: {this.props.colorData?.m} {this.props.t('jaune')}: {this.props.colorData?.j} {this.props.t('noir')}: {this.props.colorData?.n}</span>
                        </div>
                    }
                  </div>
              }
              <button id={"add_to_cart_btn"} className={'btn btn-dt-primary cursor-pointer'} onClick={this._onClickAddToCart}>
                <Icons icon="cart" size={26} className={`shortIconMenu color mr-2 ml-2 white`}/>
                {this.props.t('add_to_cart')}
              </button>
            </div>
          </div>
        </Modal>
    );
  }
}
export default withTranslation('common')(withHostApi(ModalControl));
